import {UntypedFormGroup, Validators} from '@angular/forms';
import {
  ConfiguracaoEcg,
  ConfiguracaoEventosScc,
  HistoricoModalidadeGarantia,
  LabelTipoOperacao,
  LabelTipoOutraGarantia,
  LoteModalidadeGarantia,
  ModalidadeGarantia,
  TIPO_CALCULO_LIMITE_BENEFICIARIO,
  TIPO_CONGLOMERADO,
  TipoEstiloMenuDTO
} from '../../model/modalidade_garantia.model';
import {Tranche} from '../../model/tranche.model';
import {TrancheService} from '../../shared/services/tranche.service';

import {Component, Injector, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ModalidadeGarantiaService} from './modalidade-garantia.service';
import moment from 'moment';
import {BnMaskParser} from '@bndes/bndes-ux4/bn-mask/bn-mask-parser';
import {BnModalMessageService} from '@bndes/bndes-ux4/bn-modal-message';
import {BnUsuarioService, Usuario} from '@bndes/bndes-ux4/bn-usuario';
import {BaseEntityComponent, BnLoadingService, EntityPagedRequestParameters} from '@bndes/bndes-ux4/bndes-angular-utils';
import {PermissaoService} from 'src/app/shared/permissao.service';
import {ROLE_GESTOR_ENVIO} from 'src/app/constantes/permissao.constants';
import {OcorrenciaValidacaoVO} from 'src/app/shared/ocorrencia-validacao.vo';
import {RemoverAlertasService} from 'src/app/shared/services/remover-alertas.service';
import {AppComponent} from 'src/app/app.component';
import {NgbModal, NgbModalRef, NgbNavChangeEvent} from '@ng-bootstrap/ng-bootstrap';
import {ModalPercentuaisGarantidosComponent} from './modal-percentuais-garantidos/modal-percentuais-garantidos.component';
import {ModalOutrasGarantiasComponent} from './modal-outras-garantias/modal-outras-garantias.component';
import {ModalValidacaoInadimplenciaComponent} from './modal-validacao-inadimplencia/modal-validacao-inadimplencia.component';
import {Dominio, TaxaAtualizacaoGarantiaDTO, TipoOutraGarantia} from 'src/app/model/dominio-operacao.model';
import {MensagemService} from '../mensagem.service';
import {ModalTaxaAtualizacaoGarantiaComponent} from './modal-taxa-atualizacao-garantia/modal-taxa-atualizacao-garantia.component';
import {DatePipe} from '@angular/common';
import {OperacaoCreditoLivreService} from '../contratacao/operacao/operacao-credito-livre.service';
import {OperacaoCreditoLivreDominioIndexador} from 'src/app/model/operacao-credito-livre-dominio-indexador';
import {
  ModalEncerrarTaxaAtualizacaoGarantiaComponent
} from './modal-encerrar-taxa-atualizacao-garantia/modal-encerrar-taxa-atualizacao-garantia.component';
import {ModalidadeOperacionalCreditoLivre} from 'src/app/model/modalidade-operacional-credito-livre-model';

const setUtc = "T00:00:00-03:00";

@Component({
    selector: 'app-modalidade-garantia',
    templateUrl: './modalidade-garantia.component.html',
    styleUrls: ['./modalidade-garantia.component.scss'],
    standalone: false
})
export class ModalidadeGarantiaComponent extends BaseEntityComponent<ModalidadeGarantia> implements OnInit {

  public formModalidadeGarantia: UntypedFormGroup = null;
  public modalidade: ModalidadeGarantia;
  public modalidades: ModalidadeGarantia[]; //variável que contém as informações de todas as modalidades
  public loteModalidade: LoteModalidadeGarantia; //variável que contém informações em lote de das modalidades
  public tranches: Tranche[] = [];
  public tipoEstiloMenu: TipoEstiloMenuDTO[] = [];
  public estiloMenu: string;
  private opcoesTipoCalculoLimiteBeneficiario = TIPO_CALCULO_LIMITE_BENEFICIARIO;
  public opcoesTiposConglomerados = TIPO_CONGLOMERADO;
  public labelsOutraGarantia = LabelTipoOutraGarantia;
  public labelsOperacao = LabelTipoOperacao
  public bnMaskParser = new BnMaskParser('CNPJ'); // this.bnMaskParser.format no preenche form
  public permissaoEdicao: boolean;
  private usuarioLogado: Usuario;
  public habilitaEditar: boolean = false;
  private ocorrencias: OcorrenciaValidacaoVO[] = [];
  private anexo: File;
  public podeCadastrarModalidade: boolean;
  public modoCadastro: boolean;
  public historico: HistoricoModalidadeGarantia;
  public pesquisado: boolean = false;
  public atributosPaginacao: EntityPagedRequestParameters;
  public opcoesPaginacao: number[];
  public listaHistoricos: any[];
  public countHistoricos: number;
  private historicoCarregado: boolean;
  public abaAtiva: string;
  public percentuaisGarantiaPermitidos: number[] = null;
  public dominio: Dominio = new Dominio();
  public todosTiposOutrasGarantias: TipoOutraGarantia[];
  public siglasModalidadesValidacaoInadimplenciaTecnica: string[];
  public siglasModalidadesValidacaoInadimplenciaFinanceira: string[];
  public siglasModalidadesValidacaoInadimplenciaBeneficiario : string[];
  public msgSucessoCadastro: string = "A opção selecionada foi cadastrada com sucesso na modalidade atual.";
  public msgAvisoCadastro: string = "Todas as opções possíveis já estão registradas na modalidade atual.";
  public taxasAtualizacaoGarantia: TaxaAtualizacaoGarantiaDTO[];
  public verTaxasDesativadas: boolean = false;
  public modalidadesOpe: ModalidadeOperacionalCreditoLivre[] = [];
  public indexadores: OperacaoCreditoLivreDominioIndexador[] = [];
  public dataAtual = new Date();
  public idTagExcluir: number;
  private _textIndexador = 'Indexador';

  @ViewChild('msgTemplateExcluir') msgTemplateExcluir: TemplateRef<any>;
  @ViewChild('botoesPersonalizadosExcluir') botoesPersonalizadosExcluir: TemplateRef<any>;

  constructor(private modalidadeGarantiaService: ModalidadeGarantiaService,
    private trancheService: TrancheService,
    protected injector: Injector,
    private usuarioService: BnUsuarioService,
    private permissaoService: PermissaoService,
    private removerAlertasService: RemoverAlertasService,
    private modalService: BnModalMessageService,
    private abrirModal: NgbModal, //criado para abrir as modais das abas
    private loadingService: BnLoadingService,
    private mensagemService: MensagemService,
    private appComponent: AppComponent,
    protected operacaoCreditoLivreService: OperacaoCreditoLivreService,
    private datePipe: DatePipe) {
    super(modalidadeGarantiaService);
    this.permissaoEdicao = false;
  }

  get  indexadorText(): string {
    return this._textIndexador;
  }

  set indexadorText(ind: string) {
    this._textIndexador = ind;
  }

  public ngOnInit(): void {
    this.buscarTranches();
    this.historicoCarregado = false;

    this.formModalidadeGarantia = this.createReactiveForm();
    this.usuarioService.usuario$.subscribe(usuario => this.usuarioLogado = usuario);
    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe(resp => {
      this.permissaoEdicao = resp[ROLE_GESTOR_ENVIO];
      this.podeCadastrarModalidade = resp && resp[ROLE_GESTOR_ENVIO];
      this.modalidadeGarantiaService.buscarModalidade().subscribe((modalidade: any) => {
        this.modalidade = modalidade;
        if(modalidade.id == 3) {
          this.indexadorText = 'TAG'; 
        }
        this.preencheForm(modalidade);
        this.setModel(modalidade);
        this.formModalidadeGarantia.disable();
        this.buscarTipoEstiloMenu();
        this.opcoesPaginacao = [10, 5];
        this.atributosPaginacao = {
          page: 1,
          pageSize: this.opcoesPaginacao[1]
        };

        this.pesquisar(this.atributosPaginacao);
      })
      this.modalidadeGarantiaService.buscarModalidades().subscribe((loteModalidade: any) => {
        this.loteModalidade = loteModalidade;
        this.modalidades = this.loteModalidade.modalidades;
      })
      this.buscarTiposOutrasGarantias();
      this.buscarTiposContratoFichaCobranca();
    })
  }
  public onTabChange($event: NgbNavChangeEvent): void {
    this.abaAtiva = $event.nextId;
    console.log("ABA ATUAL: " + this.abaAtiva);

    if(!this.percentuaisGarantiaPermitidos && this.abaAtiva === "percentuais garantidos" && !this.modoCadastro) {

      this.buscarPercentuaisGarantiaPermitidos();
    }
    if(!this.dominio.tiposOutrasGarantias && this.abaAtiva === "outras garantias" && !this.modoCadastro) {
      this.buscarOutrasGarantiasPermitidas();
    }
    if(!this.siglasModalidadesValidacaoInadimplenciaTecnica && !this.siglasModalidadesValidacaoInadimplenciaFinanceira &&
      this.abaAtiva === "inadimplencia_af" && !this.modoCadastro) {
      this.buscarModalidadesValidacaoTecnica();
      this.buscarModalidadesValidacaoFinanceira();
    }
    if(!this.siglasModalidadesValidacaoInadimplenciaBeneficiario && this.abaAtiva === "inadimplencia_beneficiario") {
      this.buscarModalidadesValidacaoBeneficiario();
    }

    if (!this.taxasAtualizacaoGarantia && this.abaAtiva === "taxaAtualizacaoGarantia") {
      this.carregaTaxasAtualizacaoGarantia();
    }

    if (this.abaAtiva === "histórico") {
      this.addClasseFormLabel();
    }
  }

  public mudancaPagina(novaPagina: EntityPagedRequestParameters): void {

    this.atributosPaginacao = novaPagina;
    console.log('mudancaPagina', novaPagina);
    this.pesquisar(this.atributosPaginacao);

  }

  public pesquisar(pesq: EntityPagedRequestParameters): void {

    let posInicial, posFinal;
    posInicial = (pesq.page - 1) * pesq.pageSize;
    posFinal = posInicial + pesq.pageSize;

    if (posFinal > this.model.historicos.length) {
      posFinal = this.model.historicos.length;
    }

    this.listaHistoricos = this.model.historicos.slice(posInicial, posFinal);
    this.countHistoricos = this.model.historicos.length;
  }

  public createReactiveForm(): UntypedFormGroup {
    const form = this.formBuilder.group({

      id: [null, Validators.required],
      nome: [null, [Validators.required, Validators.maxLength(32)]],
      sigla: [null, [Validators.required, Validators.maxLength(15), Validators.pattern(/^[A-Za-z0-9_\-]+$/)]],
      descricao: [null, [Validators.required, Validators.maxLength(100)]],
      cnpjResponsavelFundo: [null, Validators.required],
      dataResolucaoDiretoriaCriacaoFundo: [null, Validators.required],
      dataCriacao: [null],
      numeroDecisaoDiretoriaCriacaoFundo: [null, Validators.required],
      numeroContaContrapartidaPagamentoHonra: [null, Validators.required],
      numeroContaContrapartidaRecebimentoEcg: [null, Validators.maxLength(10)],
      numeroContaContrapartidaRecebimentoRecuperacaoCredito: [null, Validators.maxLength(10)],
      numeroContaRecursosCoberturaGarantia: [null],
      dataLimiteUltimaAmortizacao: [null],
      codigoEventoIpd: [null],
      emailAdministrador: [null, Validators.required],
      idTipoCalculoLimiteBeneficiario: [null],
      numeroContaContabilConfrontoHonraCreditoLivre: [null],
      numeroContaContabilConfrontoHonraRepasse: [null],
      identificadorBancoEmpresaSap: [null],
      identificadorCoordenadasContaSap: [null],
      identificadorFinalidadeTedPagamentoHonraSap: [null],
      aceitaOperacaoCreditoLivre: [null],
      aceitaOperacaoRepasseSistema15: [null],
      aceitaOperacaoRepasseSistema89: [null],
      aceitaModalidadeGiro: [null],
      aceitaModalidadeInvestimento: [null],
      aceitaBeneficiarioPessoaFisicaCreditoLivre: [null],
      aceitaBeneficiarioPessoaFisicaRepasse: [null],
      aceitaPatrimonioLiquido: [null],
      aceitaSubscricaoCota: [null],
      utilizaRemuneracaoCoberturaMaxima: [null],
      textoTermoRemuneracaoCoberturaMaxima: [null],
      textoTermoEmpresasBloqueadas: [null],
      textoTermoInformeLiquidacao:[null],
      textoTermoRenunciaLimiteAdicional:[null],
      idTipoConglomerado: [null],
      aceitaHabilitacaoAlternativa: [null],
      usaLimiteAporte: [null],
      utilizaLimiteRiscoCredito: [null],
      utilizaEmpresasBloqueadas: [null],
      aceitaAlteracaoPercentualGarantido: [null],
      utilizaTaxaAtualizacaoGarantia: [null],
      utilizaCnaesGrandesEmpresas: [null],
      utilizaDadosScrNaValidacaoDeSolicitacaoHonra: [null],
      realizaCalculoTaxasEquivalentes: [null],
      aceitaUtilizacaoApiExternaFg2: [null],
      necessarioTratarValorTotalDosRecursosDaTranche: [null],
      permiteAditivoSubstituicaoBeneficiario: [null],
      cobrancaEcgEstaAtiva: [null],
      textoTermosContratacao: [null, Validators.required],
      configuracaoEcg: [null],
      configuracaoEventosSCC: [null],
      mensagemAvisoScr: [null],
      nomeValorCredito: [null, Validators.required],
      prazoMaximoEnvioLiberacaoOperacoesGiroEmDias: [null],
      textoObservacaoLimiteTotal: [null],
      textoTermosEnvioDevolucaoHonra: [null, Validators.required],
      utilizaAtualizacaoInformacaoAcompanhamentoProcessual: [null],
      utilizaAtualizacaoInformacaoClassificacaoRisco: [null],
      utilizaRelatorioPENG: [null],
      utilizaRelatorioSaldoGarantido: [null],
      utilizaRemuneracaoValidacaoLimiteFundo: [null],
      estiloMenu: [{ value: null }, Validators.required],
      // ConfiguracaoECG
      ideTipoEcgRepasseSomadoAoSaldo: [null, Validators.required],
      ideTipoEcgRepasseIncluidoNoSaldo: [null],
      ideTipoEcgRepasseBoletoRepassadoAoCliente: [null],
      ideTipoEcgRepassePagoPorTerceiros: [null],
      codigoTipoContratoEcgCreditoLivre: [null],
      codigoTipoContratoEcgRepasse: [null],
      alteraValorEcgEmAditivo: [null],
      ideUnidadeMonetariaRelatorioRepasseEcgParaOperacoesRepasse: [null],
      valorAliquotaFixaEcg: [null],
      // ConfiguracaoEventosSCC
      // ECG
      codigoEventoRetencaoECGRepasse: [null],
      codigoEventoEstornoRetencaoECGRepasse: [null],
      codigoEventoECGCreditoLivreCobrado: [null],
      codigoEventoEstornoECGCreditoLivreCobrado: [null],
      codigoEventoECGRepasseCobrado: [null],
      codigoEventoEstornoECGRepasseCobrado: [null],
      // Honra
      codigoEventoHonraCreditoLivre: [null],
      codigoEventoHonraPagamentoParcelasVencidas: [null],
      codigoEventoHonraLiquidacaoSaldoVincendo: [null],
      codigoEventoEstornoHonraRepasse: [null],
      codigoEventoHonraLiquidacaoSaldoVincendoNoContratoOriginal: [null, Validators.required],
      // Recuperacão de Crédtio
      codigoEventoRecuperacaoCreditoHistoricoRepasse: [null],
      codigoEventoEstornoRecuperacaoCreditoHistoricoRepasse: [null],
      codigoEventoRecuperacaoCreditoHistoricoCreditoLivre: [null],
      codigoEventoEstornoRecuperacaoCreditoHistoricoCreditoLivre: [null],
      codigoEventoRecuperacaoCreditoAtualizacao: [null],
      codigoEventoEstornoRecuperacaoCreditoAtualizacao: [null],
      codigoEventoRecuperacaoCreditoRemuneracao: [null],
      codigoEventoEstornoRecuperacaoCreditoRemuneracao: [null],
      codigoEventoRecuperacaoCreditoMulta: [null],
      // Leilão
      codigoEventoLeilaoRepasse: [null],
      codigoEventoRemuneracaoLeilao: [null],
      codigoEventoLeilaoCreditoLivre: [null],
      codigoEventoBaixaLeilaoCreditoLivre: [null],
      codigoEventoBaixaLeilaoRepasse: [null],
      codigoEventoEstornoLeilaoRepasse: [null],
      codigoEventoEstornoLeilaoCreditoLivre: [null],
      codigoEventoEstornoRemuneracaoLeilao: [null],
      codigoEventoEstornoBaixaLeilaoRepasse: [null],
      codigoEventoEstornoBaixaLeilaoCreditoLivre: [null],
      // Reversão de Honra
      codigoEventoReversaoHonraHistoricoRepasse: [null],
      codigoEventoEstornoReversaoHonraHistoricoRepasse: [null],
      codigoEventoReversaoHonraHistoricoCreditoLivre: [null],
      codigoEventoEstornoReversaoHonraHistoricoCreditoLivre: [null],
      codigoEventoReversaoHonraAtualizacao: [null],
      codigoEventoEstornoReversaoHonraAtualizacao: [null],
      codigoEventoReversaoHonraRemuneracao: [null],
      codigoEventoEstornoReversaoHonraRemuneracao: [null],
      codigoEventoReversaoHonraMulta: [null],
      // Cobrança
      codigoCoordenacaoFichaCobranca: [null],
      codigoFonteRecursos: [null],
      codigoTipoContratoHonra: [null],
      codigoModalidadeFichaCobranca: [null],
      // limitePagamentoDevolucaoHonra: [null], campo obsoleto
      // Validação de Inadimplência
      siglasModalidadesValidacaoInadimplenciaTecnica: [null],
      siglasModalidadesValidacaoInadimplenciaFinanceira: [null],
      realizaValidacaoInadimplenciaFinanceiraNoFgiTradicional: [null],
      siglasModalidadesValidacaoInadimplenciaBeneficiario: [null],
	    realizaValidacaoInadimplenciaBeneficiarioNoFgiTradicional: [null],
      // Outras Garantias
      outrasGarantiasPermitidas: [null],
      percentuaisGarantiaPermitidos: [null],
      existeLimiteAgenteFinanceiroTranche: [null],
      utilizaLeilao: [null],
      realizaUploadDocsAcompanhamento: [null],
      utilizaPagamentoDeEcgPorTerceiros: [null],
      identificadorFinalidadeTedPagamentoEcgTerceirosSap: [null],
      // Taxa de Atualizacao de Garantia
      // verTaxasDesativadas: [false]
    });

    return form;
  }

  public preencheForm(model: ModalidadeGarantia): void {

    this.formModalidadeGarantia.patchValue({
      id: model.id,
      nome: model.nome,
      sigla: model.sigla,
      descricao: model.descricao,
      cnpjResponsavelFundo: model.cnpjResponsavelFundo,
      dataResolucaoDiretoriaCriacaoFundo: model.dataResolucaoDiretoriaCriacaoFundo == null ? null : moment(model.dataResolucaoDiretoriaCriacaoFundo).toDate(),
      dataCriacao: model.dataCriacao == null ? null : moment(model.dataCriacao).toDate(),
      numeroDecisaoDiretoriaCriacaoFundo: model.numeroDecisaoDiretoriaCriacaoFundo,
      numeroContaContrapartidaPagamentoHonra: model.numeroContaContrapartidaPagamentoHonra,
      numeroContaContrapartidaRecebimentoEcg: model.numeroContaContrapartidaRecebimentoEcg,
      numeroContaContrapartidaRecebimentoRecuperacaoCredito: model.numeroContaContrapartidaRecebimentoRecuperacaoCredito,
      numeroContaRecursosCoberturaGarantia: model.numeroContaRecursosCoberturaGarantia,
      dataLimiteUltimaAmortizacao: model.dataLimiteUltimaAmortizacao == null ? null : moment(model.dataLimiteUltimaAmortizacao).toDate(),
      codigoEventoIpd: model.codigoEventoIpd,
      emailAdministrador: model.emailAdministrador,
      idTipoCalculoLimiteBeneficiario: model.idTipoCalculoLimiteBeneficiario,
      numeroContaContabilConfrontoHonraCreditoLivre: model.numeroContaContabilConfrontoHonraCreditoLivre,
      numeroContaContabilConfrontoHonraRepasse: model.numeroContaContabilConfrontoHonraRepasse,
      identificadorBancoEmpresaSap: model.identificadorBancoEmpresaSap,
      identificadorCoordenadasContaSap: model.identificadorCoordenadasContaSap,
      identificadorFinalidadeTedPagamentoHonraSap: model.identificadorFinalidadeTedPagamentoHonraSap,
      aceitaOperacaoCreditoLivre: model.aceitaOperacaoCreditoLivre,
      aceitaOperacaoRepasseSistema15: model.aceitaOperacaoRepasseSistema15,
      aceitaOperacaoRepasseSistema89: model.aceitaOperacaoRepasseSistema89,
      aceitaModalidadeGiro: model.aceitaModalidadeGiro,
      aceitaModalidadeInvestimento: model.aceitaModalidadeInvestimento,
      aceitaBeneficiarioPessoaFisicaCreditoLivre: model.aceitaBeneficiarioPessoaFisicaCreditoLivre,
      aceitaBeneficiarioPessoaFisicaRepasse : model.aceitaBeneficiarioPessoaFisicaRepasse,
      aceitaPatrimonioLiquido : model.aceitaPatrimonioLiquido,
      aceitaSubscricaoCota : model.aceitaSubscricaoCota,
      utilizaRemuneracaoCoberturaMaxima : model.utilizaRemuneracaoCoberturaMaxima,
      textoTermoRemuneracaoCoberturaMaxima: model.textoTermoRemuneracaoCoberturaMaxima,
      textoTermoEmpresasBloqueadas: model.textoTermoEmpresasBloqueadas,
      textoTermoInformeLiquidacao: model.textoTermoInformeLiquidacao,
      textoTermoRenunciaLimiteAdicional: model.textoTermoRenunciaLimiteAdicional,
      idTipoConglomerado : model.idTipoConglomerado,
      aceitaHabilitacaoAlternativa : model.aceitaHabilitacaoAlternativa,
      usaLimiteAporte : model.usaLimiteAporte,
      utilizaLimiteRiscoCredito : model.utilizaLimiteRiscoCredito,
      utilizaEmpresasBloqueadas : model.utilizaEmpresasBloqueadas,
      aceitaAlteracaoPercentualGarantido : model.aceitaAlteracaoPercentualGarantido,
      utilizaTaxaAtualizacaoGarantia : model.utilizaTaxaAtualizacaoGarantia,
      utilizaCnaesGrandesEmpresas : model.utilizaCnaesGrandesEmpresas,
      utilizaDadosScrNaValidacaoDeSolicitacaoHonra: model.utilizaDadosScrNaValidacaoDeSolicitacaoHonra,
      realizaCalculoTaxasEquivalentes: model.realizaCalculoTaxasEquivalentes,
      aceitaUtilizacaoApiExternaFg2: model.aceitaUtilizacaoApiExternaFg2,
      necessarioTratarValorTotalDosRecursosDaTranche: model.necessarioTratarValorTotalDosRecursosDaTranche,
      permiteAditivoSubstituicaoBeneficiario: model.permiteAditivoSubstituicaoBeneficiario,
      cobrancaEcgEstaAtiva: model.cobrancaEcgEstaAtiva,
      textoTermosContratacao: model.textoTermosContratacao,
      estiloMenu: model?.estiloMenu,
      mensagemAvisoScr: model.mensagemAvisoSCR, //
      nomeValorCredito: model.nomeValorCredito, //
      prazoMaximoEnvioLiberacaoOperacoesGiroEmDias: model.prazoMaximoEnvioLiberacaoOperacoesGiroEmDias, //
      textoObservacaoLimiteTotal: model.textoObservacaoLimiteTotal, //
      textoTermosEnvioDevolucaoHonra: model.textoTermosEnvioDevolucaoHonra, //
      utilizaAtualizacaoInformacaoAcompanhamentoProcessual: model.utilizaAtualizacaoInformacaoAcompanhamentoProcessual, //
      utilizaAtualizacaoInformacaoClassificacaoRisco: model.utilizaAtualizacaoInformacaoClassificacaoRisco, //
      utilizaRelatorioPENG: model.utilizaRelatorioPENG, //
      utilizaRelatorioSaldoGarantido: model.utilizaRelatorioSaldoGarantido, //
      utilizaRemuneracaoValidacaoLimiteFundo: model.utilizaRemuneracaoValidacaoLimiteFundo, //
      // configuracaoEcg: model?.configuracaoEcg,
      // configuracaoEventosSCC: model?.configuracaoEventosScc,
      // ConfiguracaoECG
      ideTipoEcgRepasseSomadoAoSaldo: model.configuracaoEcg?.ideTipoEcgRepasseSomadoAoSaldo,
      ideTipoEcgRepasseIncluidoNoSaldo: model.configuracaoEcg?.ideTipoEcgRepasseIncluidoNoSaldo,
      ideTipoEcgRepasseBoletoRepassadoAoCliente: model.configuracaoEcg?.ideTipoEcgRepasseBoletoRepassadoAoCliente,
      ideTipoEcgRepassePagoPorTerceiros: model.configuracaoEcg?.ideTipoEcgRepassePagoPorTerceiros,
      codigoTipoContratoEcgCreditoLivre: model.configuracaoEcg?.codigoTipoContratoEcgCreditoLivre,
      codigoTipoContratoEcgRepasse: model.configuracaoEcg?.codigoTipoContratoEcgRepasse,
      alteraValorEcgEmAditivo: model.configuracaoEcg?.alteraValorEcgEmAditivo,
      ideUnidadeMonetariaRelatorioRepasseEcgParaOperacoesRepasse: model.configuracaoEcg?.ideUnidadeMonetariaRelatorioRepasseEcgParaOperacoesRepasse,
      valorAliquotaFixaEcg: model.configuracaoEcg?.valorAliquotaFixaEcg,
      // ConfiguracaoEventosSCC
      // ECG
      codigoEventoRetencaoECGRepasse: model.configuracaoEventosScc?.codigoEventoRetencaoECGRepasse,
      codigoEventoEstornoRetencaoECGRepasse: model.configuracaoEventosScc?.codigoEventoEstornoRetencaoECGRepasse,
      codigoEventoECGCreditoLivreCobrado: model.configuracaoEventosScc?.codigoEventoECGCreditoLivreCobrado,
      codigoEventoEstornoECGCreditoLivreCobrado: model.configuracaoEventosScc?.codigoEventoEstornoECGCreditoLivreCobrado,
      codigoEventoECGRepasseCobrado: model.configuracaoEventosScc?.codigoEventoECGRepasseCobrado,
      codigoEventoEstornoECGRepasseCobrado: model.configuracaoEventosScc?.codigoEventoEstornoECGRepasseCobrado,
      // Honra
      codigoEventoHonraCreditoLivre: model.configuracaoEventosScc?.codigoEventoHonraCreditoLivre,
      codigoEventoHonraPagamentoParcelasVencidas: model.configuracaoEventosScc?.codigoEventoHonraPagamentoParcelasVencidas,
      codigoEventoHonraLiquidacaoSaldoVincendo: model.configuracaoEventosScc?.codigoEventoHonraLiquidacaoSaldoVincendo,
      codigoEventoHonraLiquidacaoSaldoVincendoNoContratoOriginal: model.configuracaoEventosScc?.codigoEventoHonraLiquidacaoSaldoVincendoNoContratoOriginal,
      codigoEventoEstornoHonraRepasse: model.configuracaoEventosScc?.codigoEventoEstornoHonraRepasse,
      // Recuperacão de Crédtio
      codigoEventoRecuperacaoCreditoHistoricoRepasse: model.configuracaoEventosScc?.codigoEventoRecuperacaoCreditoHistoricoRepasse,
      codigoEventoEstornoRecuperacaoCreditoHistoricoRepasse: model.configuracaoEventosScc?.codigoEventoEstornoRecuperacaoCreditoHistoricoRepasse,
      codigoEventoRecuperacaoCreditoHistoricoCreditoLivre: model.configuracaoEventosScc?.codigoEventoRecuperacaoCreditoHistoricoCreditoLivre,
      codigoEventoEstornoRecuperacaoCreditoHistoricoCreditoLivre: model.configuracaoEventosScc?.codigoEventoEstornoRecuperacaoCreditoHistoricoCreditoLivre,
      codigoEventoRecuperacaoCreditoAtualizacao: model.configuracaoEventosScc?.codigoEventoRecuperacaoCreditoAtualizacao,
      codigoEventoEstornoRecuperacaoCreditoAtualizacao: model.configuracaoEventosScc?.codigoEventoEstornoRecuperacaoCreditoAtualizacao,
      codigoEventoRecuperacaoCreditoRemuneracao: model.configuracaoEventosScc?.codigoEventoRecuperacaoCreditoRemuneracao,
      codigoEventoEstornoRecuperacaoCreditoRemuneracao: model.configuracaoEventosScc?.codigoEventoEstornoRecuperacaoCreditoRemuneracao,
      codigoEventoRecuperacaoCreditoMulta: model.configuracaoEventosScc?.codigoEventoRecuperacaoCreditoMulta,
      // Leilão
      codigoEventoLeilaoRepasse: model.configuracaoEventosScc?.codigoEventoLeilaoRepasse,
      codigoEventoLeilaoCreditoLivre: model.configuracaoEventosScc?.codigoEventoLeilaoCreditoLivre,
      codigoEventoRemuneracaoLeilao: model.configuracaoEventosScc?.codigoEventoRemuneracaoLeilao,
      codigoEventoBaixaLeilaoRepasse: model.configuracaoEventosScc?.codigoEventoBaixaLeilaoRepasse,
      codigoEventoBaixaLeilaoCreditoLivre: model.configuracaoEventosScc?.codigoEventoBaixaLeilaoCreditoLivre,
      codigoEventoEstornoLeilaoRepasse: model.configuracaoEventosScc?.codigoEventoEstornoLeilaoRepasse,
      codigoEventoEstornoLeilaoCreditoLivre: model.configuracaoEventosScc?.codigoEventoEstornoLeilaoCreditoLivre,
      codigoEventoEstornoRemuneracaoLeilao: model.configuracaoEventosScc?.codigoEventoEstornoRemuneracaoLeilao,
      codigoEventoEstornoBaixaLeilaoRepasse: model.configuracaoEventosScc?.codigoEventoEstornoBaixaLeilaoRepasse,
      codigoEventoEstornoBaixaLeilaoCreditoLivre: model.configuracaoEventosScc?.codigoEventoEstornoBaixaLeilaoCreditoLivre,
      // Reversão de Honra
      codigoEventoReversaoHonraHistoricoRepasse: model.configuracaoEventosScc?.codigoEventoReversaoHonraHistoricoRepasse,
      codigoEventoEstornoReversaoHonraHistoricoRepasse: model.configuracaoEventosScc?.codigoEventoEstornoReversaoHonraHistoricoRepasse,
      codigoEventoReversaoHonraHistoricoCreditoLivre: model.configuracaoEventosScc?.codigoEventoReversaoHonraHistoricoCreditoLivre,
      codigoEventoEstornoReversaoHonraHistoricoCreditoLivre: model.configuracaoEventosScc?.codigoEventoEstornoReversaoHonraHistoricoCreditoLivre,
      codigoEventoReversaoHonraAtualizacao: model.configuracaoEventosScc?.codigoEventoReversaoHonraAtualizacao,
      codigoEventoEstornoReversaoHonraAtualizacao: model.configuracaoEventosScc?.codigoEventoEstornoReversaoHonraAtualizacao,
      codigoEventoReversaoHonraRemuneracao: model.configuracaoEventosScc?.codigoEventoReversaoHonraRemuneracao,
      codigoEventoEstornoReversaoHonraRemuneracao: model.configuracaoEventosScc?.codigoEventoEstornoReversaoHonraRemuneracao,
      codigoEventoReversaoHonraMulta: model.configuracaoEventosScc?.codigoEventoReversaoHonraMulta,
      // Cobrança
      codigoCoordenacaoFichaCobranca: model.codigoCoordenacaoFichaCobranca,
      codigoFonteRecursos: model.codigoFonteRecursos,
      codigoTipoContratoHonra: model.codigoTipoContratoHonra,
      codigoModalidadeFichaCobranca: model.codigoModalidadeFichaCobranca,
      // Incluir depois novo campo de limite pagamento devolução honra (dias)
      // Validação de Inadimplência de agente financeiro
      siglasModalidadesValidacaoInadimplenciaTecnica: model.siglasModalidadesValidacaoInadimplenciaTecnica,
      siglasModalidadesValidacaoInadimplenciaFinanceira: model.siglasModalidadesValidacaoInadimplenciaFinanceira,
      realizaValidacaoInadimplenciaFinanceiraNoFgiTradicional: model.realizaValidacaoInadimplenciaFinanceiraNoFgiTradicional,
      // Validação de Inadimplência de beneficiáriox
      siglasModalidadesValidacaoInadimplenciaBeneficiario: model.siglasModalidadesValidacaoInadimplenciaBeneficiario,
	    realizaValidacaoInadimplenciaBeneficiarioNoFgiTradicional: model.realizaValidacaoInadimplenciaBeneficiarioNoFgiTradicional,
      // Outras Garantias
      //outrasGarantiasPermitidas: this.labelOutraGarantia(model.outrasGarantiasPermitidas),
      //percentuaisGarantiaPermitidos: model.percentuaisGarantiaPermitidos.join(';')
      existeLimiteAgenteFinanceiroTranche: model.existeLimiteAgenteFinanceiroTranche,
      utilizaLeilao: model.utilizaLeilao,
      realizaUploadDocsAcompanhamento: model.realizaUploadDocsAcompanhamento,
      utilizaPagamentoDeEcgPorTerceiros: model.utilizaPagamentoDeEcgPorTerceiros,
      identificadorFinalidadeTedPagamentoEcgTerceirosSap: model.identificadorFinalidadeTedPagamentoEcgTerceirosSap
    })
  }

  public habilitarEdicao() {
    if (this.modoCadastro) this.formModalidadeGarantia.get('id').enable();
    this.formModalidadeGarantia.get('nome').enable();
    this.formModalidadeGarantia.get('sigla').enable();
    this.formModalidadeGarantia.get('descricao').enable();
    this.formModalidadeGarantia.get('cnpjResponsavelFundo').enable();
    this.formModalidadeGarantia.get('dataResolucaoDiretoriaCriacaoFundo').enable();
    this.formModalidadeGarantia.get('dataCriacao').enable();
    this.formModalidadeGarantia.get('numeroDecisaoDiretoriaCriacaoFundo').enable();
    this.formModalidadeGarantia.get('numeroContaContrapartidaPagamentoHonra').enable();
    this.formModalidadeGarantia.get('numeroContaContrapartidaRecebimentoEcg').enable();
    this.formModalidadeGarantia.get('numeroContaContrapartidaRecebimentoRecuperacaoCredito').enable();
    this.formModalidadeGarantia.get('numeroContaRecursosCoberturaGarantia').enable();
    this.formModalidadeGarantia.get('dataLimiteUltimaAmortizacao').enable();
    this.formModalidadeGarantia.get('codigoEventoIpd').enable();
    this.formModalidadeGarantia.get('emailAdministrador').enable();
    this.formModalidadeGarantia.get('idTipoCalculoLimiteBeneficiario').enable();
    this.formModalidadeGarantia.get('numeroContaContabilConfrontoHonraCreditoLivre').enable();
    this.formModalidadeGarantia.get('numeroContaContabilConfrontoHonraRepasse').enable();
    this.formModalidadeGarantia.get('identificadorBancoEmpresaSap').enable();
    this.formModalidadeGarantia.get('identificadorCoordenadasContaSap').enable();
    this.formModalidadeGarantia.get('identificadorFinalidadeTedPagamentoHonraSap').enable();
    this.formModalidadeGarantia.get('aceitaOperacaoCreditoLivre').enable();
    this.formModalidadeGarantia.get('aceitaOperacaoRepasseSistema15').enable();
    this.formModalidadeGarantia.get('aceitaOperacaoRepasseSistema89').enable();
    this.formModalidadeGarantia.get('aceitaModalidadeGiro').enable();
    this.formModalidadeGarantia.get('aceitaModalidadeInvestimento').enable();
    this.formModalidadeGarantia.get('aceitaBeneficiarioPessoaFisicaCreditoLivre').enable();
    this.formModalidadeGarantia.get('aceitaBeneficiarioPessoaFisicaRepasse').enable();
    this.formModalidadeGarantia.get('aceitaPatrimonioLiquido').enable();
    this.formModalidadeGarantia.get('aceitaSubscricaoCota').enable();
    this.formModalidadeGarantia.get('utilizaRemuneracaoCoberturaMaxima').enable();
    this.formModalidadeGarantia.get('textoTermoRemuneracaoCoberturaMaxima').enable();
    this.formModalidadeGarantia.get('textoTermoEmpresasBloqueadas').enable();
    this.formModalidadeGarantia.get('textoTermoInformeLiquidacao').enable();
    this.formModalidadeGarantia.get('textoTermoRenunciaLimiteAdicional').enable();
    this.formModalidadeGarantia.get('idTipoConglomerado').enable();
    this.formModalidadeGarantia.get('aceitaHabilitacaoAlternativa').enable();
    this.formModalidadeGarantia.get('usaLimiteAporte').enable();
    this.formModalidadeGarantia.get('utilizaLimiteRiscoCredito').enable();
    this.formModalidadeGarantia.get('utilizaEmpresasBloqueadas').enable();
    this.formModalidadeGarantia.get('aceitaAlteracaoPercentualGarantido').enable();
    this.formModalidadeGarantia.get('utilizaTaxaAtualizacaoGarantia').enable();
    this.formModalidadeGarantia.get('utilizaCnaesGrandesEmpresas').enable();
    this.formModalidadeGarantia.get('utilizaDadosScrNaValidacaoDeSolicitacaoHonra').enable();
    this.formModalidadeGarantia.get('realizaCalculoTaxasEquivalentes').enable();
    this.formModalidadeGarantia.get('aceitaUtilizacaoApiExternaFg2').enable();
    this.formModalidadeGarantia.get('necessarioTratarValorTotalDosRecursosDaTranche').enable();
    this.formModalidadeGarantia.get('permiteAditivoSubstituicaoBeneficiario').enable();
    this.formModalidadeGarantia.get('estiloMenu').enable();
    this.formModalidadeGarantia.get('textoTermosContratacao').enable();
    this.formModalidadeGarantia.get('ideTipoEcgRepasseSomadoAoSaldo').enable();
    this.formModalidadeGarantia.get('ideTipoEcgRepasseIncluidoNoSaldo').enable();
    this.formModalidadeGarantia.get('ideTipoEcgRepasseBoletoRepassadoAoCliente').enable();
    this.formModalidadeGarantia.get('ideTipoEcgRepassePagoPorTerceiros').enable();
    this.formModalidadeGarantia.get('codigoTipoContratoEcgCreditoLivre').enable();
    this.formModalidadeGarantia.get('codigoTipoContratoEcgRepasse').enable();
    this.formModalidadeGarantia.get('alteraValorEcgEmAditivo').enable();
    this.formModalidadeGarantia.get('ideUnidadeMonetariaRelatorioRepasseEcgParaOperacoesRepasse').enable();
    this.formModalidadeGarantia.get('valorAliquotaFixaEcg').enable();
    this.formModalidadeGarantia.get('mensagemAvisoScr').enable();
    this.formModalidadeGarantia.get('nomeValorCredito').enable();
    this.formModalidadeGarantia.get('prazoMaximoEnvioLiberacaoOperacoesGiroEmDias').enable();
    this.formModalidadeGarantia.get('textoObservacaoLimiteTotal').enable();
    this.formModalidadeGarantia.get('textoTermosEnvioDevolucaoHonra').enable();
    this.formModalidadeGarantia.get('utilizaAtualizacaoInformacaoAcompanhamentoProcessual').enable();
    this.formModalidadeGarantia.get('utilizaAtualizacaoInformacaoClassificacaoRisco').enable();
    this.formModalidadeGarantia.get('utilizaRelatorioPENG').enable();
    this.formModalidadeGarantia.get('utilizaRelatorioSaldoGarantido').enable();
    this.formModalidadeGarantia.get('utilizaRemuneracaoValidacaoLimiteFundo').enable();
    this.formModalidadeGarantia.get('utilizaLeilao').enable();
    this.formModalidadeGarantia.get('realizaUploadDocsAcompanhamento').enable();
    this.formModalidadeGarantia.get('utilizaPagamentoDeEcgPorTerceiros').enable();
    this.formModalidadeGarantia.get('identificadorFinalidadeTedPagamentoEcgTerceirosSap').enable();

    // if (this.model.configuracaoEventosScc.codigoEventoRetencaoECGRepasse = null) {
       this.formModalidadeGarantia.get('codigoEventoRetencaoECGRepasse').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoEstornoRetencaoECGRepasse = null) {
       this.formModalidadeGarantia.get('codigoEventoEstornoRetencaoECGRepasse').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoECGCreditoLivreCobrado = null) {
       this.formModalidadeGarantia.get('codigoEventoECGCreditoLivreCobrado').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoECGCreditoLivreCobrado = null) {
       this.formModalidadeGarantia.get('codigoEventoECGCreditoLivreCobrado').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoEstornoECGCreditoLivreCobrado = null) {
       this.formModalidadeGarantia.get('codigoEventoEstornoECGCreditoLivreCobrado').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoECGRepasseCobrado = null) {
       this.formModalidadeGarantia.get('codigoEventoECGRepasseCobrado').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoEstornoECGRepasseCobrado = null) {
       this.formModalidadeGarantia.get('codigoEventoEstornoECGRepasseCobrado').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoHonraCreditoLivre = null) {
       this.formModalidadeGarantia.get('codigoEventoHonraCreditoLivre').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoHonraPagamentoParcelasVencidas = null) {
       this.formModalidadeGarantia.get('codigoEventoHonraPagamentoParcelasVencidas').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoHonraLiquidacaoSaldoVincendo = null) {
       this.formModalidadeGarantia.get('codigoEventoHonraLiquidacaoSaldoVincendo').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoHonraLiquidacaoSaldoVincendoNoContratoOriginal = null) {
       this.formModalidadeGarantia.get('codigoEventoHonraLiquidacaoSaldoVincendoNoContratoOriginal').enable();
       this.formModalidadeGarantia.get('codigoEventoEstornoHonraRepasse').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoRecuperacaoCreditoHistoricoRepasse = null) {
       this.formModalidadeGarantia.get('codigoEventoRecuperacaoCreditoHistoricoRepasse').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoEstornoRecuperacaoCreditoHistoricoRepasse = null) {
       this.formModalidadeGarantia.get('codigoEventoEstornoRecuperacaoCreditoHistoricoRepasse').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoRecuperacaoCreditoHistoricoCreditoLivre = null) {
       this.formModalidadeGarantia.get('codigoEventoRecuperacaoCreditoHistoricoCreditoLivre').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoEstornoRecuperacaoCreditoHistoricoCreditoLivre = null) {
       this.formModalidadeGarantia.get('codigoEventoEstornoRecuperacaoCreditoHistoricoCreditoLivre').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoRecuperacaoCreditoAtualizacao = null) {
       this.formModalidadeGarantia.get('codigoEventoRecuperacaoCreditoAtualizacao').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoEstornoRecuperacaoCreditoAtualizacao = null) {
       this.formModalidadeGarantia.get('codigoEventoEstornoRecuperacaoCreditoAtualizacao').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoRecuperacaoCreditoRemuneracao = null) {
       this.formModalidadeGarantia.get('codigoEventoRecuperacaoCreditoRemuneracao').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoEstornoRecuperacaoCreditoRemuneracao = null) {
       this.formModalidadeGarantia.get('codigoEventoEstornoRecuperacaoCreditoRemuneracao').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoRecuperacaoCreditoMulta = null) {
       this.formModalidadeGarantia.get('codigoEventoRecuperacaoCreditoMulta').enable();
    // }

    this.formModalidadeGarantia.get('codigoEventoLeilaoRepasse').enable();
    this.formModalidadeGarantia.get('codigoEventoEstornoLeilaoRepasse').enable();
    this.formModalidadeGarantia.get('codigoEventoRemuneracaoLeilao').enable();
    this.formModalidadeGarantia.get('codigoEventoEstornoRemuneracaoLeilao').enable();
    this.formModalidadeGarantia.get('codigoEventoLeilaoCreditoLivre').enable();

    this.formModalidadeGarantia.get('codigoEventoEstornoLeilaoCreditoLivre').enable();
    this.formModalidadeGarantia.get('codigoEventoBaixaLeilaoCreditoLivre').enable();
    this.formModalidadeGarantia.get('codigoEventoBaixaLeilaoRepasse').enable();
    this.formModalidadeGarantia.get('codigoEventoEstornoBaixaLeilaoCreditoLivre').enable();
    this.formModalidadeGarantia.get('codigoEventoEstornoBaixaLeilaoRepasse').enable();

    // if (this.model.configuracaoEventosScc.codigoEventoReversaoHonraHistoricoRepasse = null) {
       this.formModalidadeGarantia.get('codigoEventoReversaoHonraHistoricoRepasse').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoEstornoReversaoHonraHistoricoRepasse = null) {
       this.formModalidadeGarantia.get('codigoEventoEstornoReversaoHonraHistoricoRepasse').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoReversaoHonraHistoricoCreditoLivre = null) {
       this.formModalidadeGarantia.get('codigoEventoReversaoHonraHistoricoCreditoLivre').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoEstornoReversaoHonraHistoricoCreditoLivre = null) {
       this.formModalidadeGarantia.get('codigoEventoEstornoReversaoHonraHistoricoCreditoLivre').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoReversaoHonraAtualizacao = null) {
       this.formModalidadeGarantia.get('codigoEventoReversaoHonraAtualizacao').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoEstornoReversaoHonraAtualizacao = null) {
       this.formModalidadeGarantia.get('codigoEventoEstornoReversaoHonraAtualizacao').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoReversaoHonraRemuneracao = null) {
       this.formModalidadeGarantia.get('codigoEventoReversaoHonraRemuneracao').enable();
    // }
    // if (this.model.configuracaoEventosScc.codigoEventoEstornoReversaoHonraRemuneracao = null) {
       this.formModalidadeGarantia.get('codigoEventoEstornoReversaoHonraRemuneracao').enable();
    // }
    //if (this.model.codigoCoordenacaoFichaCobranca = null) {
      this.formModalidadeGarantia.get('codigoCoordenacaoFichaCobranca').enable();
    //}
    //if (this.model.codigoFonteRecursos = null) {
      this.formModalidadeGarantia.get('codigoFonteRecursos').enable();
    //}
    //if (this.model.codigoTipoContratoHonra = null) {
      this.formModalidadeGarantia.get('codigoTipoContratoHonra').enable();
    //}
    //if (this.model.codigoModalidadeFichaCobranca = null) {
      this.formModalidadeGarantia.get('codigoModalidadeFichaCobranca').enable();
    //}
      this.formModalidadeGarantia.get('codigoEventoReversaoHonraMulta').enable();
    // Incluir depois novo campo com as mesmas validações dos campos acima da aba de cobrança
    this.formModalidadeGarantia.get('siglasModalidadesValidacaoInadimplenciaTecnica').enable();
    this.formModalidadeGarantia.get('siglasModalidadesValidacaoInadimplenciaFinanceira').enable();
    this.formModalidadeGarantia.get('realizaValidacaoInadimplenciaFinanceiraNoFgiTradicional').enable();
    this.formModalidadeGarantia.get('realizaValidacaoInadimplenciaBeneficiarioNoFgiTradicional').enable();
    //this.formModalidadeGarantia.get('outrasGarantiasPermitidas').enable();
    //this.formModalidadeGarantia.get('percentuaisGarantiaPermitidos').enable();
    super.editar();
  }

  public desabilitarEdicao(): void {

    if (this.formModalidadeGarantia.pristine) {
      this.formModalidadeGarantia.disable();
      this.modoEdicao = false;
    } else {
      this.abreModalConfirmacao('Descartar alterações realizadas na modalidade?').then(resp => {
        if (resp === true) {
          this.formModalidadeGarantia.disable();
          this.modoEdicao = false;
          const modalidade = this.modalidades.find(m => m.id === this.model.id);
          if (modalidade) {
            this.preencheForm(modalidade);
          }
        }
      });
    }
  }

  public buscarTranches(): void {
    this.trancheService.getTranches().subscribe(tranches => {
      this.tranches = tranches;

    });
  }
  public buscarTipoEstiloMenu(): void {
    this.modalidadeGarantiaService.buscarTipoEstiloMenu().subscribe(res => {
      this.tipoEstiloMenu = res;
    });
  }

  public buscarHistorico(idHistorico: number): void {
    this.modalidadeGarantiaService.buscarHistoricoModalidade(idHistorico)
      .subscribe((historico: HistoricoModalidadeGarantia) => {
        this.historico = historico;
        this.pesquisado = true;
      })
  }

  public labelOutraGarantia(item): string {
    return this.labelsOutraGarantia.get(item);
  }

  public labelOperacao(item): string {
    return this.labelsOperacao.get(item);
  }

  public atualizar(): void {
    this.atualizaModel();

    this.abreModalConfirmacao('Deseja confirmar a alteração dos dados?').then(resp => {
      if (resp === true) {
        this.loadingService.bloqueiaTela();
        this.modalidadeGarantiaService.atualizarModalidade(this.model).subscribe((modalidadeAtualizada) => {
          this.mensagemService.adicionarMensagemSucesso('Modalidade de garantia alterada com sucesso.');
          this.loadingService.liberaTela();
          this.model = modalidadeAtualizada;
          this.appComponent.carregarEstiloModalidade(modalidadeAtualizada);
          this.formModalidadeGarantia.disable();
          this.modoEdicao = false;
        }, (error) => {
          this.loadingService.liberaTela();
        })
      }
    })
  }

  public salvar(): void {
    this.atualizaModel();
    console.log("model: " + JSON.stringify(this.model));

    this.abreModalConfirmacao('Deseja confirmar o cadastro da modalidade?').then(resp => {
      if (resp === true) {
        this.loadingService.bloqueiaTela();
        this.modalidadeGarantiaService.salvarModalidade(this.model).subscribe(() => {
          this.mensagemService.adicionarMensagemSucesso('Modalidade de garantia cadastrada com sucesso.');
          this.loadingService.liberaTela();
        }, (error) => {
          this.loadingService.liberaTela();
        })
      }
    })
  }

  public atualizaModel(): void {
    this.model.id = this.formModalidadeGarantia.get('id').value;
    this.model.nome = this.formModalidadeGarantia.get('nome').value;
    this.model.sigla = this.formModalidadeGarantia.get('sigla').value;
    this.model.descricao = this.formModalidadeGarantia.get('descricao').value;
    this.model.cnpjResponsavelFundo = this.formModalidadeGarantia.get('cnpjResponsavelFundo').value;
    this.model.dataResolucaoDiretoriaCriacaoFundo = this.formModalidadeGarantia.get('dataResolucaoDiretoriaCriacaoFundo').value; // formatar
    this.model.dataCriacao = this.formModalidadeGarantia.get('dataCriacao').value; // formatar
    this.model.numeroDecisaoDiretoriaCriacaoFundo = this.formModalidadeGarantia.get('numeroDecisaoDiretoriaCriacaoFundo').value;
    this.model.numeroContaContrapartidaPagamentoHonra = this.formModalidadeGarantia.get('numeroContaContrapartidaPagamentoHonra').value;
    this.model.numeroContaContrapartidaRecebimentoEcg = this.formModalidadeGarantia.get('numeroContaContrapartidaRecebimentoEcg').value;
    this.model.numeroContaContrapartidaRecebimentoRecuperacaoCredito = this.formModalidadeGarantia.get('numeroContaContrapartidaRecebimentoRecuperacaoCredito').value;
    this.model.numeroContaRecursosCoberturaGarantia = this.formModalidadeGarantia.get('numeroContaRecursosCoberturaGarantia').value;
    this.model.dataLimiteUltimaAmortizacao = this.formModalidadeGarantia.get('dataLimiteUltimaAmortizacao').value;
    this.model.codigoEventoIpd = this.formModalidadeGarantia.get('codigoEventoIpd').value;
    this.model.emailAdministrador = this.formModalidadeGarantia.get('emailAdministrador').value;
    this.model.idTipoCalculoLimiteBeneficiario = this.formModalidadeGarantia.get('idTipoCalculoLimiteBeneficiario').value;
    this.model.numeroContaContabilConfrontoHonraCreditoLivre = this.formModalidadeGarantia.get('numeroContaContabilConfrontoHonraCreditoLivre').value;
    this.model.numeroContaContabilConfrontoHonraRepasse = this.formModalidadeGarantia.get('numeroContaContabilConfrontoHonraRepasse').value;
    this.model.identificadorBancoEmpresaSap = this.formModalidadeGarantia.get('identificadorBancoEmpresaSap').value;
    this.model.identificadorCoordenadasContaSap = this.formModalidadeGarantia.get('identificadorCoordenadasContaSap').value;
    this.model.identificadorFinalidadeTedPagamentoHonraSap = this.formModalidadeGarantia.get('identificadorFinalidadeTedPagamentoHonraSap').value;
    this.model.aceitaOperacaoCreditoLivre = this.formModalidadeGarantia.get('aceitaOperacaoCreditoLivre').value == true ? true : false;
    this.model.aceitaOperacaoRepasseSistema15 = this.formModalidadeGarantia.get('aceitaOperacaoRepasseSistema15').value == true ? true : false;
    this.model.aceitaOperacaoRepasseSistema89 = this.formModalidadeGarantia.get('aceitaOperacaoRepasseSistema89').value == true ? true : false;
    this.model.aceitaModalidadeGiro = this.formModalidadeGarantia.get('aceitaModalidadeGiro').value == true ? true : false;
    this.model.aceitaModalidadeInvestimento = this.formModalidadeGarantia.get('aceitaModalidadeInvestimento').value == true ? true : false;
    this.model.aceitaBeneficiarioPessoaFisicaCreditoLivre = this.formModalidadeGarantia.get('aceitaBeneficiarioPessoaFisicaCreditoLivre').value == true ? true : false;
    this.model.aceitaBeneficiarioPessoaFisicaRepasse = this.formModalidadeGarantia.get('aceitaBeneficiarioPessoaFisicaRepasse').value == true ? true : false;
    this.model.aceitaPatrimonioLiquido = this.formModalidadeGarantia.get('aceitaPatrimonioLiquido').value == true ? true : false;
    this.model.aceitaSubscricaoCota = this.formModalidadeGarantia.get('aceitaSubscricaoCota').value == true ? true : false;
    this.model.utilizaRemuneracaoCoberturaMaxima = this.formModalidadeGarantia.get('utilizaRemuneracaoCoberturaMaxima').value == true ? true : false;
    this.model.textoTermoRemuneracaoCoberturaMaxima = this.formModalidadeGarantia.get('textoTermoRemuneracaoCoberturaMaxima').value;
    this.model.textoTermoEmpresasBloqueadas = this.formModalidadeGarantia.get('textoTermoEmpresasBloqueadas').value;
    this.model.textoTermoInformeLiquidacao = this.formModalidadeGarantia.get('textoTermoInformeLiquidacao').value;
    this.model.textoTermoRenunciaLimiteAdicional = this.formModalidadeGarantia.get('textoTermoRenunciaLimiteAdicional').value;
    const idTipoConglomerado = this.formModalidadeGarantia.get('idTipoConglomerado').value;
    this.model.idTipoConglomerado = idTipoConglomerado != null && idTipoConglomerado != 'null' ? idTipoConglomerado : null;
    this.model.aceitaHabilitacaoAlternativa = this.formModalidadeGarantia.get('aceitaHabilitacaoAlternativa').value == true ? true : false;
    this.model.usaLimiteAporte = this.formModalidadeGarantia.get('usaLimiteAporte').value == true ? true : false;
    this.model.utilizaLimiteRiscoCredito = this.formModalidadeGarantia.get('utilizaLimiteRiscoCredito').value == true ? true : false;
    this.model.utilizaEmpresasBloqueadas = this.formModalidadeGarantia.get('utilizaEmpresasBloqueadas').value == true ? true : false;
    this.model.utilizaLeilao = this.formModalidadeGarantia.get('utilizaLeilao').value == true ? true : false;
    this.model.realizaUploadDocsAcompanhamento = this.formModalidadeGarantia.get('realizaUploadDocsAcompanhamento').value == true ? true : false;
    this.model.utilizaPagamentoDeEcgPorTerceiros = this.formModalidadeGarantia.get('utilizaPagamentoDeEcgPorTerceiros').value == true ? true : false;
    this.model.identificadorFinalidadeTedPagamentoEcgTerceirosSap = this.formModalidadeGarantia.get('identificadorFinalidadeTedPagamentoEcgTerceirosSap').value;
    this.model.aceitaAlteracaoPercentualGarantido = this.formModalidadeGarantia.get('aceitaAlteracaoPercentualGarantido').value == true ? true : false;
    this.model.utilizaTaxaAtualizacaoGarantia = this.formModalidadeGarantia.get('utilizaTaxaAtualizacaoGarantia').value == true ? true : false;
    this.model.utilizaCnaesGrandesEmpresas = this.formModalidadeGarantia.get('utilizaCnaesGrandesEmpresas').value == true ? true : false;
    this.model.utilizaDadosScrNaValidacaoDeSolicitacaoHonra = this.formModalidadeGarantia.get('utilizaDadosScrNaValidacaoDeSolicitacaoHonra').value == true ? true : false;
    this.model.realizaCalculoTaxasEquivalentes = this.formModalidadeGarantia.get('realizaCalculoTaxasEquivalentes').value == true ? true : false;
    this.model.aceitaUtilizacaoApiExternaFg2 = this.formModalidadeGarantia.get('aceitaUtilizacaoApiExternaFg2').value == true ? true : false;
    this.model.necessarioTratarValorTotalDosRecursosDaTranche = this.formModalidadeGarantia.get('necessarioTratarValorTotalDosRecursosDaTranche').value == true ? true : false;
    this.model.permiteAditivoSubstituicaoBeneficiario = this.formModalidadeGarantia.get('permiteAditivoSubstituicaoBeneficiario').value == true ? true : false;
    this.model.estiloMenu = this.formModalidadeGarantia.get('estiloMenu').value;
    this.model.textoTermosContratacao = this.formModalidadeGarantia.get('textoTermosContratacao').value;
    this.model.mensagemAvisoSCR = this.formModalidadeGarantia.get('mensagemAvisoScr').value;
    this.model.nomeValorCredito = this.formModalidadeGarantia.get('nomeValorCredito').value;
    this.model.prazoMaximoEnvioLiberacaoOperacoesGiroEmDias = this.formModalidadeGarantia.get('prazoMaximoEnvioLiberacaoOperacoesGiroEmDias').value;
    this.model.textoObservacaoLimiteTotal = this.formModalidadeGarantia.get('textoObservacaoLimiteTotal').value;
    this.model.textoTermosEnvioDevolucaoHonra = this.formModalidadeGarantia.get('textoTermosEnvioDevolucaoHonra').value;
    this.model.utilizaAtualizacaoInformacaoAcompanhamentoProcessual = this.formModalidadeGarantia.get('utilizaAtualizacaoInformacaoAcompanhamentoProcessual').value == true ? true : false;
    this.model.utilizaAtualizacaoInformacaoClassificacaoRisco = this.formModalidadeGarantia.get('utilizaAtualizacaoInformacaoClassificacaoRisco').value == true ? true : false;
    this.model.utilizaRelatorioPENG = this.formModalidadeGarantia.get('utilizaRelatorioPENG').value == true ? true : false;
    this.model.utilizaRelatorioSaldoGarantido = this.formModalidadeGarantia.get('utilizaRelatorioSaldoGarantido').value == true ? true : false;
    this.model.utilizaRemuneracaoValidacaoLimiteFundo = this.formModalidadeGarantia.get('utilizaRemuneracaoValidacaoLimiteFundo').value == true ? true : false;
    this.model.configuracaoEcg.ideTipoEcgRepasseSomadoAoSaldo = this.formModalidadeGarantia.get('ideTipoEcgRepasseSomadoAoSaldo').value;
    this.model.configuracaoEcg.ideTipoEcgRepasseIncluidoNoSaldo = this.formModalidadeGarantia.get('ideTipoEcgRepasseIncluidoNoSaldo').value;
    this.model.configuracaoEcg.ideTipoEcgRepasseBoletoRepassadoAoCliente = this.formModalidadeGarantia.get('ideTipoEcgRepasseBoletoRepassadoAoCliente').value;
    this.model.configuracaoEcg.ideTipoEcgRepassePagoPorTerceiros = this.formModalidadeGarantia.get('ideTipoEcgRepassePagoPorTerceiros').value;
    this.model.configuracaoEcg.codigoTipoContratoEcgCreditoLivre = this.formModalidadeGarantia.get('codigoTipoContratoEcgCreditoLivre').value;
    this.model.configuracaoEcg.codigoTipoContratoEcgRepasse = this.formModalidadeGarantia.get('codigoTipoContratoEcgRepasse').value;
    this.model.configuracaoEcg.alteraValorEcgEmAditivo = this.formModalidadeGarantia.get('alteraValorEcgEmAditivo').value == true ? true : false;
    this.model.configuracaoEcg.ideUnidadeMonetariaRelatorioRepasseEcgParaOperacoesRepasse = this.formModalidadeGarantia.get('ideUnidadeMonetariaRelatorioRepasseEcgParaOperacoesRepasse').value;
    this.model.configuracaoEcg.valorAliquotaFixaEcg = this.formModalidadeGarantia.get('valorAliquotaFixaEcg').value;
    this.model.configuracaoEventosScc.codigoEventoRetencaoECGRepasse = this.formModalidadeGarantia.get('codigoEventoRetencaoECGRepasse').value;
    this.model.configuracaoEventosScc.codigoEventoEstornoRetencaoECGRepasse = this.formModalidadeGarantia.get('codigoEventoEstornoRetencaoECGRepasse').value;
    this.model.configuracaoEventosScc.codigoEventoECGCreditoLivreCobrado = this.formModalidadeGarantia.get('codigoEventoECGCreditoLivreCobrado').value;
    this.model.configuracaoEventosScc.codigoEventoEstornoECGCreditoLivreCobrado = this.formModalidadeGarantia.get('codigoEventoEstornoECGCreditoLivreCobrado').value;
    this.model.configuracaoEventosScc.codigoEventoECGRepasseCobrado = this.formModalidadeGarantia.get('codigoEventoECGRepasseCobrado').value;
    this.model.configuracaoEventosScc.codigoEventoEstornoECGRepasseCobrado = this.formModalidadeGarantia.get('codigoEventoEstornoECGRepasseCobrado').value;
    this.model.configuracaoEventosScc.codigoEventoHonraCreditoLivre = this.formModalidadeGarantia.get('codigoEventoHonraCreditoLivre').value;
    this.model.configuracaoEventosScc.codigoEventoHonraPagamentoParcelasVencidas = this.formModalidadeGarantia.get('codigoEventoHonraPagamentoParcelasVencidas').value;
    this.model.configuracaoEventosScc.codigoEventoHonraLiquidacaoSaldoVincendo = this.formModalidadeGarantia.get('codigoEventoHonraLiquidacaoSaldoVincendo').value;
    this.model.configuracaoEventosScc.codigoEventoHonraLiquidacaoSaldoVincendoNoContratoOriginal = this.formModalidadeGarantia.get('codigoEventoHonraLiquidacaoSaldoVincendoNoContratoOriginal').value;
    this.model.configuracaoEventosScc.codigoEventoEstornoHonraRepasse = this.formModalidadeGarantia.get('codigoEventoEstornoHonraRepasse').value;
    this.model.configuracaoEventosScc.codigoEventoRecuperacaoCreditoHistoricoRepasse = this.formModalidadeGarantia.get('codigoEventoRecuperacaoCreditoHistoricoRepasse').value;
    this.model.configuracaoEventosScc.codigoEventoEstornoRecuperacaoCreditoHistoricoRepasse = this.formModalidadeGarantia.get('codigoEventoEstornoRecuperacaoCreditoHistoricoRepasse').value;
    this.model.configuracaoEventosScc.codigoEventoRecuperacaoCreditoHistoricoCreditoLivre = this.formModalidadeGarantia.get('codigoEventoRecuperacaoCreditoHistoricoCreditoLivre').value;
    this.model.configuracaoEventosScc.codigoEventoEstornoRecuperacaoCreditoHistoricoCreditoLivre = this.formModalidadeGarantia.get('codigoEventoEstornoRecuperacaoCreditoHistoricoCreditoLivre').value;
    this.model.configuracaoEventosScc.codigoEventoRecuperacaoCreditoAtualizacao = this.formModalidadeGarantia.get('codigoEventoRecuperacaoCreditoAtualizacao').value;
    this.model.configuracaoEventosScc.codigoEventoEstornoRecuperacaoCreditoAtualizacao = this.formModalidadeGarantia.get('codigoEventoEstornoRecuperacaoCreditoAtualizacao').value;
    this.model.configuracaoEventosScc.codigoEventoRecuperacaoCreditoRemuneracao = this.formModalidadeGarantia.get('codigoEventoRecuperacaoCreditoRemuneracao').value;
    this.model.configuracaoEventosScc.codigoEventoEstornoRecuperacaoCreditoRemuneracao = this.formModalidadeGarantia.get('codigoEventoEstornoRecuperacaoCreditoRemuneracao').value;
    this.model.configuracaoEventosScc.codigoEventoRecuperacaoCreditoMulta = this.formModalidadeGarantia.get('codigoEventoRecuperacaoCreditoMulta').value;
    this.model.configuracaoEventosScc.codigoEventoReversaoHonraHistoricoRepasse = this.formModalidadeGarantia.get('codigoEventoReversaoHonraHistoricoRepasse').value;
    this.model.configuracaoEventosScc.codigoEventoEstornoReversaoHonraHistoricoRepasse = this.formModalidadeGarantia.get('codigoEventoEstornoReversaoHonraHistoricoRepasse').value;
    this.model.configuracaoEventosScc.codigoEventoReversaoHonraHistoricoCreditoLivre = this.formModalidadeGarantia.get('codigoEventoReversaoHonraHistoricoCreditoLivre').value;
    this.model.configuracaoEventosScc.codigoEventoEstornoReversaoHonraHistoricoCreditoLivre = this.formModalidadeGarantia.get('codigoEventoEstornoReversaoHonraHistoricoCreditoLivre').value;
    this.model.configuracaoEventosScc.codigoEventoReversaoHonraAtualizacao = this.formModalidadeGarantia.get('codigoEventoReversaoHonraAtualizacao').value;
    this.model.configuracaoEventosScc.codigoEventoEstornoReversaoHonraAtualizacao = this.formModalidadeGarantia.get('codigoEventoEstornoReversaoHonraAtualizacao').value;
    this.model.configuracaoEventosScc.codigoEventoReversaoHonraRemuneracao = this.formModalidadeGarantia.get('codigoEventoReversaoHonraRemuneracao').value;
    this.model.configuracaoEventosScc.codigoEventoEstornoReversaoHonraRemuneracao = this.formModalidadeGarantia.get('codigoEventoEstornoReversaoHonraRemuneracao').value;
    this.model.configuracaoEventosScc.codigoEventoReversaoHonraMulta = this.formModalidadeGarantia.get('codigoEventoReversaoHonraMulta').value;
    this.model.configuracaoEventosScc.codigoEventoLeilaoRepasse = this.formModalidadeGarantia.get('codigoEventoLeilaoRepasse').value;
    this.model.configuracaoEventosScc.codigoEventoLeilaoCreditoLivre = this.formModalidadeGarantia.get('codigoEventoLeilaoCreditoLivre').value;
    this.model.configuracaoEventosScc.codigoEventoRemuneracaoLeilao = this.formModalidadeGarantia.get('codigoEventoRemuneracaoLeilao').value;
    this.model.configuracaoEventosScc.codigoEventoBaixaLeilaoRepasse = this.formModalidadeGarantia.get('codigoEventoBaixaLeilaoRepasse').value;
    this.model.configuracaoEventosScc.codigoEventoBaixaLeilaoCreditoLivre = this.formModalidadeGarantia.get('codigoEventoBaixaLeilaoCreditoLivre').value;
    this.model.configuracaoEventosScc.codigoEventoEstornoLeilaoRepasse = this.formModalidadeGarantia.get('codigoEventoEstornoLeilaoRepasse').value;
    this.model.configuracaoEventosScc.codigoEventoEstornoLeilaoCreditoLivre = this.formModalidadeGarantia.get('codigoEventoEstornoLeilaoCreditoLivre').value;
    this.model.configuracaoEventosScc.codigoEventoEstornoRemuneracaoLeilao = this.formModalidadeGarantia.get('codigoEventoEstornoRemuneracaoLeilao').value;
    this.model.configuracaoEventosScc.codigoEventoEstornoBaixaLeilaoRepasse = this.formModalidadeGarantia.get('codigoEventoEstornoBaixaLeilaoRepasse').value;
    this.model.configuracaoEventosScc.codigoEventoEstornoBaixaLeilaoCreditoLivre = this.formModalidadeGarantia.get('codigoEventoEstornoBaixaLeilaoCreditoLivre').value;
    this.model.codigoCoordenacaoFichaCobranca = this.formModalidadeGarantia.get('codigoCoordenacaoFichaCobranca').value;
    this.model.codigoFonteRecursos = this.formModalidadeGarantia.get('codigoFonteRecursos').value;
    this.model.codigoTipoContratoHonra = this.formModalidadeGarantia.get('codigoTipoContratoHonra').value;
    this.model.codigoModalidadeFichaCobranca = this.formModalidadeGarantia.get('codigoModalidadeFichaCobranca').value;
    // Incluir depois novo campo da quantidade de dias limite
    this.model.siglasModalidadesValidacaoInadimplenciaTecnica = this.formModalidadeGarantia.get('siglasModalidadesValidacaoInadimplenciaTecnica').value;
    this.model.siglasModalidadesValidacaoInadimplenciaFinanceira = this.formModalidadeGarantia.get('siglasModalidadesValidacaoInadimplenciaFinanceira').value;
    this.model.realizaValidacaoInadimplenciaFinanceiraNoFgiTradicional = this.formModalidadeGarantia.get('realizaValidacaoInadimplenciaFinanceiraNoFgiTradicional').value  == true ? true : false;
    //this.model.percentuaisGarantiaPermitidos = this.formModalidadeGarantia.get('percentuaisGarantiaPermitidos').value.split(";");
    this.model.siglasModalidadesValidacaoInadimplenciaBeneficiario = this.formModalidadeGarantia.get('siglasModalidadesValidacaoInadimplenciaBeneficiario').value;
    this.model.realizaValidacaoInadimplenciaBeneficiarioNoFgiTradicional = this.formModalidadeGarantia.get('realizaValidacaoInadimplenciaBeneficiarioNoFgiTradicional').value  == true ? true : false;
    this.model.existeLimiteAgenteFinanceiroTranche = this.formModalidadeGarantia.get('existeLimiteAgenteFinanceiroTranche').value  == true ? true : false;
  }

  public async abreModalConfirmacao(mensagem: string): Promise<boolean> {
    const titulo = 'Confirmação';

    try {
      const resultadoConfimacao = await this.modalService.abrirConfirm(titulo, mensagem).result;
      return resultadoConfimacao.value === 'ok';
    } catch (e) {
        return false;
    }
  }

  public opcaoCadastro(): void {
    this.modoCadastro = true;
    this.formModalidadeGarantia.reset( {
      aceitaOperacaoRepasseSistema15: false, aceitaOperacaoRepasseSistema89: false, aceitaOperacaoCreditoLivre: false, aceitaBeneficiarioPessoaFisicaCreditoLivre: false,
      aceitaBeneficiarioPessoaFisicaRepasse: false, aceitaPatrimonioLiquido: false, aceitaSubscricaoCota: false, utilizaRemuneracaoCoberturaMaxima: false, aceitaHabilitacaoAlternativa: false, usaLimiteAporte: false, utilizaCnaesGrandesEmpresas: false, aceitaModalidadeGiro: false,
      aceitaModalidadeInvestimento: false, aceitaUtilizacaoApiExternaFg2: false, utilizaAtualizacaoInformacaoAcompanhamentoProcessual: false,
      utilizaAtualizacaoInformacaoClassificacaoRisco: false, utilizaDadosScrNaValidacaoDeSolicitacaoHonra: false, utilizaIndicadorEscoParaProgramasAceitos: false,
      utilizaRelatorioPENG: false, utilizaRelatorioSaldoGarantido: false, utilizaRemuneracaoValidacaoLimiteFundo: false, realizaCalculoTaxasEquivalentes: false, realizaValidacaoInadimplenciaFinanceiraNoFgiTradicional: false,
      necessarioTratarValorTotalDosRecursosDaTranche: false, permiteAditivoSubstituicaoBeneficiario: false, cobrancaEcgEstaAtiva: false, alteraValorEcgEmAditivo: false
    })
    this.model = new ModalidadeGarantia();
    this.model.configuracaoEcg = new ConfiguracaoEcg();
    this.model.configuracaoEventosScc = new ConfiguracaoEventosScc();
    this.percentuaisGarantiaPermitidos = [];
    this.dominio.tiposOutrasGarantias = [];
    this.siglasModalidadesValidacaoInadimplenciaFinanceira = [];
    this.siglasModalidadesValidacaoInadimplenciaTecnica = [];
    this.siglasModalidadesValidacaoInadimplenciaBeneficiario = [];
/*
    this.model.outrasGarantiasPermitidas = [];
    this.model.siglasModalidadesValidacaoInadimplenciaTecnica = [];
    this.model.siglasModalidadesValidacaoInadimplenciaFinanceira = [];
    this.model.percentuaisGarantiaPermitidos = [];
    this.model.faixasDeContratos = [];
    this.model.historicos = [];
*/
    this.listaHistoricos = [];
    this.historico = null;
    this.countHistoricos = 0;
    this.formModalidadeGarantia.enable();
  }

  public voltarParaLista(): void {
    this.abreModalConfirmacao('Descartar novo cadastro de modalidade?').then(resp => {
      if (resp === true) {
        this.model = this.modalidade;
        this.modoCadastro = false;
        this.buscarPercentuaisGarantiaPermitidos();
        this.buscarOutrasGarantiasPermitidas();
        this.preencheForm(this.model);
        this.formModalidadeGarantia.disable();
        this.pesquisar(this.atributosPaginacao);
        this.buscarModalidadesValidacaoTecnica();
        this.buscarModalidadesValidacaoFinanceira();
        this.buscarModalidadesValidacaoBeneficiario();


      }
    })
  }

  public fecharHistorico(): void {
    this.pesquisado = false;
  }

  public buscarPercentuaisGarantiaPermitidos(): void { //busca os percentuais garantidos da modalidade corrente
    this.modalidadeGarantiaService.buscarPercentuaisGarantiaPermitidos().subscribe((data: any) => {
      this.percentuaisGarantiaPermitidos = data;
    })
  }

  public buscarOutrasGarantiasPermitidas(): void { //busca as outras garantias da modalidade corrente
    this.modalidadeGarantiaService.buscarOutrasGarantiasPermitidas().subscribe((data: any) => {
      this.dominio.tiposOutrasGarantias = data;
    })
  }

  public buscarTiposOutrasGarantias(): void { //busca todos os tipos de outras garantias existentes (criado para mostrar na comboBox da aba 'Outras Garantias')
    this.modalidadeGarantiaService.buscarTiposOutrasGarantias().subscribe((data: any) => {
      this.todosTiposOutrasGarantias = data;
    })
  }

  public buscarTiposContratoFichaCobranca(): void { //busca todos os tipos de contrato (criado para mostrar na comboBox da aba 'Cobrança')
    this.modalidadeGarantiaService.buscarTiposContratoFichaCobranca().subscribe((data: any) => {
      this.dominio.tiposContratoFichaCobranca = data;
    })
  }

  public buscarModalidadesValidacaoTecnica(): void { //busca as modalidades para validação técnica da modalidade corrente
    this.modalidadeGarantiaService.buscarModalidadesInadimplenciaTecnica().subscribe((data: any) =>{
      this.siglasModalidadesValidacaoInadimplenciaTecnica = data;
    })
  }

  public buscarModalidadesValidacaoFinanceira(): void { //busca as modalidades para validação financeira da modalidade corrente
    this.modalidadeGarantiaService.buscarModalidadesInadimplenciaFinanceira().subscribe((data: any) =>{
      this.siglasModalidadesValidacaoInadimplenciaFinanceira = data;
    })
  }

  public buscarModalidadesValidacaoBeneficiario(): void {
    this.modalidadeGarantiaService.buscarModalidadesInadimplenciaBeneficiario().subscribe((data: any) =>{
      this.siglasModalidadesValidacaoInadimplenciaBeneficiario = data;
    })
  }

  public adicionarGarantia(): void {
    const modalRef: NgbModalRef = this.abrirModal.open(ModalOutrasGarantiasComponent)

    const possiveis_garantias: TipoOutraGarantia[] = this.retirarGarantiasExistentes(this.dominio.tiposOutrasGarantias);

    if (this.conferirListaEscolhasVazia(possiveis_garantias, this.msgAvisoCadastro)) {
      modalRef.close();
      return;
    }

    modalRef.componentInstance.todosTiposOutrasGarantias = possiveis_garantias;
    modalRef.result.then((resultado) => {
      if (resultado.botao === 'salvar') {

        this.dominio.tiposOutrasGarantias.push(resultado.valor);
        this.loadingService.bloqueiaTela();
        this.modalidadeGarantiaService.salvarGarantia(this.dominio.tiposOutrasGarantias).subscribe((data: any) => {
          this.mensagemService.adicionarMensagemSucesso(this.msgSucessoCadastro)
          this.loadingService.liberaTela();
          this.desabilitarEdicao();
          this.dominio.tiposOutrasGarantias = data;
        }, (error) => {
          this.loadingService.liberaTela();
        });
      }
    });

  }

  public adicionarPercentualGarantido(): void {
    const modalRef: NgbModalRef = this.abrirModal.open(ModalPercentuaisGarantidosComponent);
    modalRef.result.then((resultado) => {
      if (resultado.botao === 'salvar') {
        for(const valor_comparativo of this.percentuaisGarantiaPermitidos) {

          if (valor_comparativo == resultado.valor) {
            this.mensagemService.adicionarMensagemAviso('Valor já cadastrado na modalidade atual.');
            return;
          }
      }

        this.percentuaisGarantiaPermitidos.push(resultado.valor);

        this.loadingService.bloqueiaTela();
        this.modalidadeGarantiaService.salvarPercentualGarantido(this.percentuaisGarantiaPermitidos).subscribe((data: any) => {
          this.mensagemService.adicionarMensagemSucesso('Percentual garantido cadastrado com sucesso!');
          this.loadingService.liberaTela();
          this.desabilitarEdicao();
          this.percentuaisGarantiaPermitidos = data;
        }, (error) => {
          this.loadingService.liberaTela();
        });
      }
    });

  }

  public adicionarModalidadeInadimplenciaTecnica() {
    const modalRef: NgbModalRef = this.abrirModal.open(ModalValidacaoInadimplenciaComponent);
    const possiveisModalidadesInadimplenciaTecnica: ModalidadeGarantia[] = this.retirarModalidadesExistentes(this.siglasModalidadesValidacaoInadimplenciaTecnica);


    if (this.conferirListaEscolhasVazia(possiveisModalidadesInadimplenciaTecnica, this.msgAvisoCadastro)) {
      modalRef.close();
      return;
    }

    modalRef.componentInstance.modalidades = possiveisModalidadesInadimplenciaTecnica;
    modalRef.result.then((resultado) => {
      if (resultado.botao == "salvar") {
        this.siglasModalidadesValidacaoInadimplenciaTecnica.push(resultado.valor)

        this.modalidadeGarantiaService.salvarModalidadeInadimplenciaTecnica(this.siglasModalidadesValidacaoInadimplenciaTecnica).subscribe((data) => {
          this.loadingService.bloqueiaTela();
          this.mensagemService.adicionarMensagemSucesso(this.msgSucessoCadastro);
          this.siglasModalidadesValidacaoInadimplenciaTecnica = data
          this.loadingService.liberaTela();
        });

      }
    });



  }

  public adicionarModalidadeInadimplenciaFinanceira() {
    const modalRef: NgbModalRef = this.abrirModal.open(ModalValidacaoInadimplenciaComponent);


    let possiveisModalidadesInadimplenciaFinanceira: ModalidadeGarantia[]= this.retirarModalidadesExistentes(this.siglasModalidadesValidacaoInadimplenciaFinanceira);

    if (this.conferirListaEscolhasVazia(possiveisModalidadesInadimplenciaFinanceira, this.msgAvisoCadastro)) {
      modalRef.close();
      return;
    }
    modalRef.componentInstance.modalidades = possiveisModalidadesInadimplenciaFinanceira;
    modalRef.result.then((resultado) => {
      if (resultado.botao == "salvar") {
        this.siglasModalidadesValidacaoInadimplenciaFinanceira.push(resultado.valor)

        this.modalidadeGarantiaService.salvarModalidadeInadimplenciaFinanceira(this.siglasModalidadesValidacaoInadimplenciaFinanceira).subscribe((data) => {
          this.loadingService.bloqueiaTela();
          this.mensagemService.adicionarMensagemSucesso(this.msgSucessoCadastro);
          this.siglasModalidadesValidacaoInadimplenciaFinanceira = data
          this.loadingService.liberaTela();
        });
      }
    });

  }

  public adicionarModalidadeInadimplenciaBeneficiario() {
    const modalRef: NgbModalRef = this.abrirModal.open(ModalValidacaoInadimplenciaComponent);


    let possiveisModalidadesInadimplenciaBeneficiario : ModalidadeGarantia[] = this.retirarModalidadesExistentes(this.siglasModalidadesValidacaoInadimplenciaBeneficiario);

    if (this.conferirListaEscolhasVazia(possiveisModalidadesInadimplenciaBeneficiario, this.msgAvisoCadastro)) {
      modalRef.close();
      return;
    }
    modalRef.componentInstance.modalidades = possiveisModalidadesInadimplenciaBeneficiario;
    modalRef.result.then((resultado) => {
      if (resultado.botao == "salvar") {
        this.siglasModalidadesValidacaoInadimplenciaBeneficiario.push(resultado.valor)

        this.modalidadeGarantiaService.salvarModalidadeInadimplenciaBeneficiario(this.siglasModalidadesValidacaoInadimplenciaBeneficiario).subscribe((data) => {
          this.loadingService.bloqueiaTela();
          this.mensagemService.adicionarMensagemSucesso(this.msgSucessoCadastro);
          this.siglasModalidadesValidacaoInadimplenciaBeneficiario = data
          this.loadingService.liberaTela();
        });
      }
    });




  }

  public adicionarTaxaAtualizacaoGarantia(): void {
    this.carregarModalidades().then(()=> {
      this.chamaModalAdicionarTaxaAtualizacaoGarantia();
    })
  }

  public chamaModalAdicionarTaxaAtualizacaoGarantia() {
    const modalRef = this.abrirModal.open(ModalTaxaAtualizacaoGarantiaComponent, {
      windowClass: 'modal-dialog-md',
      backdrop: 'static',
      size:'lg'
    });

    modalRef.componentInstance.modalidadesOpe = this.modalidadesOpe;
    modalRef.componentInstance.indexadores = this.indexadores;

    modalRef.result.then((resultado) => {
      if (resultado.botao === 'salvar') {
        this.carregaTaxasAtualizacaoGarantia();
      }
    });
  }

  public onMudaTab(event: any) {
    if (event.nextId == 1) {
      if (!this.historicoCarregado) {
        this.modalidadeGarantiaService.carregaHistoricosModalidade()
          .subscribe(l => {
            this.model.historicos = l;
            this.historicoCarregado = true;
            this.pesquisar(this.atributosPaginacao);
          });

      }
    }
  }


  //Retira valores que já estão cadastrados nas modalidades de inadimplencia técnica, financeira e beneficiario
  public retirarModalidadesExistentes(modalidadesCadastradas: string[]): ModalidadeGarantia[] {
    let possiveisModalidades: ModalidadeGarantia[] = Object.create(this.modalidades);

    modalidadesCadastradas.forEach((valor) => {
      possiveisModalidades = possiveisModalidades.filter(item => item.sigla != valor);
    });
    return possiveisModalidades;

  }
  //Retira valores que já estão cadastrados nas garantias
  public retirarGarantiasExistentes(garantiasCadastradas: TipoOutraGarantia[]): TipoOutraGarantia[] {
    let possiveisGarantias : TipoOutraGarantia[] = Object.create(this.todosTiposOutrasGarantias);

    garantiasCadastradas.forEach((valor) => {
      possiveisGarantias = possiveisGarantias.filter(item => item.codigo != valor.codigo);
    });
    return possiveisGarantias;
  }

  public conferirListaEscolhasVazia(listaOpcoesVazia: (ModalidadeGarantia|TipoOutraGarantia)[], msgError: string): boolean {
  //Confiro se existe mais alguma modalidade ou garantia a ser adicionada, caso contrário warning
    if (!listaOpcoesVazia.length) {
      this.mensagemService.adicionarMensagemAviso(msgError);
      return true;
    }
    return false;
  }

  public carregaTaxasAtualizacaoGarantia() {
    let dadosPreenchidos: any = {
      desativados: this.verTaxasDesativadas,
      pagina: 1,
      limite: 50,
    }

    this.loadingService.bloqueiaTela();
    this.modalidadeGarantiaService
      .buscarTaxasAtualizacaoGarantia(dadosPreenchidos)
        .subscribe((response) => {
          this.taxasAtualizacaoGarantia = response.resultados;
          this.loadingService.liberaTela();
          this.carregaIndexadores();
        }, (error) => {
          this.mensagemService.adicionarMensagemErro("Erro ao buscar indexadores.");
          this.loadingService.liberaTela();
        })
  }

  public changeVerTaxasDesativadas() {
    this.carregaTaxasAtualizacaoGarantia();
  }

  async carregarModalidades() {
    try {
      this.loadingService.bloqueiaTela();
      this.modalidadesOpe = await this.modalidadeGarantiaService.buscarModalidadesOperacionais().toPromise();
    } catch (err) {
      this.mensagemService.adicionarMensagemErro("Erro ao buscar modalidades operacionais.");
    } finally {
      this.loadingService.liberaTela();
    }
  }

  public carregaIndexadores() {
    if (this.indexadores.length === 0) {
      this.modalidadeGarantiaService.buscarIndexadores().subscribe((response) => {
        this.indexadores = response;
      });
    }
  }


  public podeEncerrarTAG(tag: TaxaAtualizacaoGarantiaDTO): boolean {
    const dataInicio = new Date(tag.dataInicioValidade);
    const dataFim = tag.dataFinalValidade ? new Date(tag.dataFinalValidade) : null;
    return dataInicio <= this.dataAtual && dataFim === null;
  }

  public podeExcluirTAG(tag: TaxaAtualizacaoGarantiaDTO): boolean {
    const dataInicio = new Date(tag.dataInicioValidade);
    return dataInicio > this.dataAtual;
  }

  public modalEncerrarTAG(tag: TaxaAtualizacaoGarantiaDTO) {
    const modalRef = this.abrirModal.open(ModalEncerrarTaxaAtualizacaoGarantiaComponent, {
      windowClass: 'modal-dialog-md',
      backdrop: 'static',
      size:'lg'
    });

    const dataInicio = new Date(`${tag.dataInicioValidade+setUtc}`);
    modalRef.componentInstance.dataInicioValidade = dataInicio;
    modalRef.componentInstance.idTag = tag.id;

    modalRef.result.then((resultado) => {
      if (resultado.botao === 'salvar') {
        this.carregaTaxasAtualizacaoGarantia();
      }
    });
  }

  modalConfirmarExclusao(event: Event, id: number) {
    event.stopPropagation();
    this.idTagExcluir = id;
    this.modalService.abrir(
      'Confirmação',
      'Esta ação irá excluir o % da taxa de atualização da garantia selecionado.',
      'lg',
      this.msgTemplateExcluir,
      this.botoesPersonalizadosExcluir
    );
  }

  excluirTAG() {
    let id = this.idTagExcluir;
    if (id) {
      this.loadingService.bloqueiaTela();
      this.modalidadeGarantiaService.excluirTaxaAtualizacaoGarantia(id)
        .subscribe(() => {
          this.mensagemService.adicionarMensagemSucesso("% da taxa de atualização da garantia excluído com sucesso.");
          this.loadingService.liberaTela();
          this.fecharModalExcluirTAG();
          this.carregaTaxasAtualizacaoGarantia();
        }, (error) => {
          this.mensagemService.adicionarMensagemErro("Erro ao tentar excluír % da taxa de atualização da garantia.");
          this.fecharModalExcluirTAG();
          this.loadingService.liberaTela();
        })
    }
  }

  fecharModalExcluirTAG() {
    this.modalService.dismiss();
  }

  public tagInativa(tag: TaxaAtualizacaoGarantiaDTO): boolean {
    const dataAtual = new Date();
    dataAtual.setHours(0, 0, 0, 0);
    const dataFinalValidade = new Date(`${tag.dataFinalValidade+setUtc}`);
    return tag.dataFinalValidade !== null && dataFinalValidade < dataAtual;
  }

  addClasseFormLabel() {
    setTimeout(() => {
      const bnPaginacao = document.getElementById('ngHistorico');
      const labels = bnPaginacao.getElementsByTagName('label');
      for (let i =0; i < labels.length; i++) {
        labels[i].classList.add('form-label');
      }
    }, 0)
  }

}


